export function getMessage(state) {
    return state.message;
}
export default {
    getMessage,
};
